import { RouteType } from "types/RouteType";
import type { RootStore } from "stores/index";
import CheckPrintingStore from "./CheckPrinting.Store";

/**
 * Check Printing Route
 *
 * View for printing checks with customizable templates
 * per Implementation Plan Phase 1: Check Printing
 *
 * Features:
 * - Select payments to print
 * - Choose from company-specific templates
 * - Preview before printing
 * - Ascending/Descending print order
 * - Test print on blank paper
 */
const checkPrintingRoute: RouteType = {
  name: "Check Printing",
  path: "/accounting/check-printing",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Check Printing",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./CheckPrinting.Header"),
    },
    body: {
      component: () => import("./CheckPrinting.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  showCompanySelector: true,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    rootStore.appLayoutStore?.initializeSelectedPlant();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const store = (rootStore as any).checkPrintingStore as CheckPrintingStore;
    if (store) {
      await store.loadData();
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const store = (rootStore as any).checkPrintingStore as CheckPrintingStore;
    if (store) {
      await store.loadData();
    }
  },
  dialogs: [
    {
      name: "templateDesigner",
      title: "Check Template Designer",
      component: () => import("./dialogs/TemplateDesigner.Body"),
      cancelButton: true,
      height: 600,
    },
    {
      name: "printPreview",
      title: "Print Preview",
      component: () => import("./dialogs/PrintPreview.Body"),
      cancelButton: true,
      height: 700,
    },
    {
      name: "printConfirmation",
      title: "Confirm Printed Checks",
      component: () => import("./dialogs/PrintConfirmation.Body"),
      cancelButton: false,
      height: 500,
    },
    {
      name: "printHistory",
      title: "Print History",
      component: () => import("./dialogs/PrintHistory.Body"),
      cancelButton: true,
      height: 600,
    },
  ],
};

export default checkPrintingRoute;
